import styled from 'foundations-theming/utils';
export const StyledFolderNavItemWrapper = styled.div.attrs({
  tabIndex: 0
}).withConfig({
  displayName: "styled__StyledFolderNavItemWrapper"
})(["background:", ";cursor:pointer;display:flex;line-height:16px;padding:8px;position:relative;z-index:1000;border-radius:3px;"], ({
  isSelected,
  theme: {
    color
  }
}) => isSelected ? color['fill-info-subtle'] : undefined);
export const StyledCountWrapper = styled.span.withConfig({
  displayName: "styled__StyledCountWrapper"
})(["color:", ";margin-left:8px;"], ({
  theme: {
    color
  }
}) => color['text-core-disabled']);